
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


declare var $: any;


@Component({
    selector: 'app-alert-error',
    templateUrl: './alert-error.html',
    styleUrls: ['./alert-error.less'],
    standalone: false
})
export class AlertError implements OnInit {





  constructor(public dialog: MatDialog, public dialogRef:MatDialogRef<AlertError>) {



   }



  ngOnInit() {


  }

  close(){
    this.dialogRef.close(true)
  }


}